/* @flow */
// import SignUp from 'forms/CreateAccount/CreateAccount.js';
import Welcome from 'forms/CreateAccount/Welcome';

import { loginRoles } from 'permissions/general';

/**
 * TODO: Refactor those views into proper route files.
 */
import { LoggingIn } from 'views/AccountLogin/LoggingIn';
import NewAccount from 'views/AccountLogin/NewAccount';
import ForgottenPassword from 'views/AccountLogin/ForgottenPassword';
import MagicLink from 'views/AccountLogin/MagicLink';
import PasswordReset from 'views/AccountLogin/PasswordReset';
import ChangePassword from 'views/AccountLogin/ChangePassword';
import PasswordUpdated from 'views/AccountLogin/PasswordUpdated';
import LoginFailed from 'views/AccountLogin/LoginFailed';
import ValidateMagicLink from 'views/AccountLogin/ValidateMagicLink';
import LoginForm from 'views/AccountLogin/LoginForm';
import ValidateJwtLink from '../views/AccountLogin/ValidateJwtLink';

const loginRoutes: Array<*> = [
  {
    path: '/login',
    title: 'general:document_titles.authentication.login',
    component: LoginForm,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/magic-link',
    title: 'general:document_titles.authentication.token_verification',
    component: MagicLink,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/validate-magic-link/:email/:token',
    title: 'general:document_titles.authentication.token_verification',
    component: ValidateMagicLink,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/validate-jwt-token',
    title: 'general:document_titles.authentication.token_verification',
    component: ValidateJwtLink,
    exact: true,
    permissions: loginRoles,
  },

  {
    path: '/signup-complete',
    title: 'general:document_titles.authentication.sign_up_complete',
    component: NewAccount,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/logging-in',
    title: 'general:document_titles.authentication.logging_in',
    component: LoggingIn,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/forgotten-password',
    title: 'general:document_titles.authentication.forgot_password',
    component: ForgottenPassword,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/get-magic-link',
    title: 'general:document_titles.authentication.forgot_password',
    component: ForgottenPassword,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/password-reset',
    title: 'general:document_titles.authentication.reset_password',
    component: PasswordReset,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/change-password/:email/:token',
    title: 'general:document_titles.authentication.reset_password',
    component: ChangePassword,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/password-updated',
    title: 'general:document_titles.authentication.password_updated',
    component: PasswordUpdated,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/login-failed',
    title: 'general:document_titles.authentication.login_failed',
    component: LoginFailed,
    exact: true,
    permissions: loginRoles,
  },
  {
    path: '/welcome',
    title: 'general:document_titles.authentication.account_created',
    component: Welcome,
    exact: true,
    permissions: loginRoles,
  },
];

export default loginRoutes;
